import React, { useMemo } from 'react'

import { Button, Icon, ArrowRight } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { arrayOf, number, shape, string } from 'prop-types'

import usePromoTracking, { LOCATION_BY_TYPE } from 'Pods/CollectionHub/Hooks/usePromoTracking'
import ImageMosaic from 'Pods/Shared/ImageMosaic/ImageMosaic'

import { EMPTY_ARRAY } from 'Utils/stableDefaults'

function CollectionCard({
  id = '',
  slug = '',
  title = '',
  description,
  imageUrl = '',
  href,
  previewImages = EMPTY_ARRAY,
  slot = 0,
  collectionType = 'cg',
}) {
  const normalizedPreviews = useMemo(
    () => (previewImages || []).filter((image) => image?.url).slice(0, 4),
    [previewImages]
  )

  const promoId = slug || id
  const { ref, handleSelect } = usePromoTracking({
    id: promoId,
    name: title,
    creative: 'hero',
    slot,
    collectionType,
  })

  if (!title || (!imageUrl && normalizedPreviews.length < 4)) {
    return null
  }

  const cardId = `collection-${title.toLowerCase().replace(/\s+/g, '-')}`
  const shouldRenderMosaic = !imageUrl && normalizedPreviews.length === 4

  return (
    <article
      ref={ref}
      className="collection-hub-card"
      aria-labelledby={`${cardId}-title`}
      data-promo-id={promoId}
      data-promo-name={title}
      data-promo-creative="hero"
      data-promo-slot={slot}
      data-promo-location={LOCATION_BY_TYPE[collectionType] || ''}
    >
      <a href={href} onClick={handleSelect} className="collection-hub-card__image-container">
        {shouldRenderMosaic ? (
          <ImageMosaic images={normalizedPreviews} />
        ) : (
          <img
            src={imageUrl}
            alt={`Preview of ${title} collection`}
            width={389}
            height={286}
            // eslint-disable-next-line react/no-unknown-property
            fetchpriority="high"
            className="collection-hub-card__image"
          />
        )}
      </a>
      <div className="collection-hub-card__content">
        <h3 id={`${cardId}-title`} className="collection-hub-card__title">
          {title}
        </h3>
        <p className="collection-hub-card__description">{description}</p>

        <Button
          type="secondary"
          trailIcon={<Icon svgComponent={ArrowRight} size="small" />}
          href={href}
          size="small"
          onClick={handleSelect}
        >
          Go to collection
        </Button>
      </div>
    </article>
  )
}

CollectionCard.propTypes = {
  id: string,
  slug: string,
  title: string,
  description: string.isRequired,
  imageUrl: string,
  href: string.isRequired,
  previewImages: arrayOf(
    shape({
      id: string.isRequired,
      url: string.isRequired,
      alt: string.isRequired,
    })
  ),
  slot: number,
  collectionType: string,
}

export default CollectionCard
